<template>
  <mdb-container>
    <!-- <mdb-btn color="default" @click.native="subs = true">launch subscrition modal <mdb-icon icon="eye" class="ml-1"/></mdb-btn> -->
    <mdb-modal :show="getToggle" @close="toggleEstimate(false)">
      <mdb-modal-header class="text-center">
        <mdb-modal-title tag="h4" bold class="w-100">Estimado</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3 grey-text text-left">
        <mdb-input label="Nombre" icon="user" class="mb-5"/>
        <mdb-input label="Email" icon="envelope" type="email" class="mb-5"/>
        <mdb-input label="Telefono" icon="phone" type="email" class="mb-5"/>
        <mdb-input type="textarea" label="Descripcion de Trabajo" :rows="5"/>
         <mdb-file-input sm btnColor="info" btn-title="Documentos" text-field-title="" />
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click.native="subs = false" color="info">Send <mdb-icon icon="paper-plane" class="ml-1"/></mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </mdb-container>
</template>

<script>
  import { mdbContainer,  mdbModal, mdbIcon, mdbModalHeader, mdbModalBody, mdbInput, mdbModalFooter, mdbBtn, mdbFileInput } from 'mdbvue';
  
  import store from '../store/index'
  export default {
    name: 'ModalExamplesPage',
    components: {
      mdbContainer,
      mdbBtn,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbInput,
      mdbModalFooter,
      mdbIcon,
      mdbFileInput,
    },
    data() {
      return {
        subs: false,
        files: []
      }
    },
    methods: {
        toggleEstimate(b){
            store.commit('toggleEstimate' , b)
        },
         handleChange(v) {
      this.files = v;
    }
    },
    computed:{
        getToggle(){
            return store.state.estimateModal
        }
    }
  }
</script>